import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  UserManagementComponent,
  LoginAttempsComponent,
  DatabaseLogsComponent,
  HospitalsPage,
  DepartmentsPage
} from '@pages/index.pages';
import { AuthGuardService } from '@services/auth-guard/auth-guard.service';
import { CanDeactivateGuard } from '@services/auth-guard/can-deactivate-guard.service';
import { SubdepartmentsPage } from './database-resources/subdepartments/subdepartments.page';
import { ConsultantsPage } from './database-resources/consultants/consultants.page';
import { EditConsultantPage } from './database-resources/consultants/edit-consultant/edit-consultant.page';
import { PinGeneratorPage } from './tools/pin-generator/pin-generator.page';
import { AppointmentsPage } from '@src/app/pages/admin-pages/consultant-pages/appointments/appointments.page';
// import { ConfigurationPage } from './database-resources/configuration/configuration.page';
import { ClearCachePage } from '@pages/admin-pages/tools/clear-cache/clear-cache.page';
import { DeletedUsersPage } from '@src/app/pages/admin-pages/reports/deleted-users/deleted-users.page';
import { RegisteredUsersPage } from '@src/app/pages/admin-pages/reports/registered-users/registered-users.page';
import { PortalParametersPage } from './portal-configuration/portal-parameters/portal-parameters.page';
import { FaqsPage } from './portal-configuration/faqs/faqs.page';
import { PayorsPage } from './database-resources/payors/payors.page';



const routes: Routes = [
  {
    path: 'user-management',
    component: UserManagementComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'portal-configuration/portal-parameters',
    component: PortalParametersPage,
    canActivate: [AuthGuardService],
  },
  {
    path: 'portal-configuration/faqs',
    component: FaqsPage,
    canActivate: [AuthGuardService],
  },
  {
    path: 'tools/clear-cache',
    component: ClearCachePage
  },
  {
    path: 'tools/pin-generator',
    component: PinGeneratorPage
  },
  {
    path: 'reports/login-attemps',
    component: LoginAttempsComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'reports/database-logs',
    component: DatabaseLogsComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'reports/deleted-users',
    component: DeletedUsersPage,
    canActivate: [AuthGuardService],
  },
  {
    path: 'reports/actived-users',
    component: RegisteredUsersPage,
    canActivate: [AuthGuardService],
  },
  {
    path: 'database-resources/hospitals',
    component: HospitalsPage,
    canActivate: [AuthGuardService],
  },
  {
    path: 'database-resources/departments',
    component: DepartmentsPage,
    canActivate: [AuthGuardService],
  },
  {
    path: 'database-resources/subdepartments',
    component: SubdepartmentsPage,
    canActivate: [AuthGuardService],
  },
  {
    path: 'database-resources/payors',
    component: PayorsPage,
    canActivate: [AuthGuardService],
  },
  {
    path: 'database-resources/consultants',
    component: ConsultantsPage,
    canActivate: [AuthGuardService],
  },
  {
    path: 'database-resources/consultants/edit-consultant',
    component: EditConsultantPage,
    canActivate: [AuthGuardService],
  },/* 
  {
    path: 'database-resources/configuration',
    component: ConfigurationPage,
    canActivate: [AuthGuardService],
  }, */
  {
    path: 'consultant/appointments',
    component: AppointmentsPage,
    canActivate: [AuthGuardService],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    CanDeactivateGuard
  ]
})
export class AdminRoutingModule { }
